import React, {
  useContext,
  useEffect,
  useState,
  useRef
} from "react";
import { Grid, Stack } from "@mui/material";
import { Routes, Route, useNavigate } from "react-router-dom";
import {
  StyledContainer,
  StyledHeader,
  StyledButtonContainer
} from "./Provider.styles";
import Button from "components/shared/Button/Button";
import Users from "./Subviews/Users/Users";
import Managers from "./Subviews/Managers/Managers";
import API from "api";
import { GlobalContext } from "context/Provider";
import Reports from "views/Provider/Subviews/Reports/Reports";
import Readings from "views/Provider/Subviews/Readings/Readings";
import Statistics from "views/Admin/subviews/Statistics/Statistics";
import Session from "helpers/session";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Upsert from "./Upsert/Upsert";
import Orders from "../Orders/Orders";
import NewOrder from "./Subviews/CreateOrder/NewOrder";
import Configurations from "./Subviews/Configurations/Configurations";
import { host, socket_url } from "../../api/kore";
import io from "socket.io-client";
import { toLastFirstName } from "helpers/variables";
import GlobalThresholds from "./Subviews/GlobalThresholds/GlobalThresholds";
import {COORDINATOR} from "../../helpers/appConstants";
import {defaultSettings} from "views/Main/Main.utils";

interface KoreListInterface {
  cid: string;
  pages: number;
  page: number;
  items: any[];
}

interface ButtonArrayProps {
  memberFilter: "all" | "locked" | "active";
  setMemberFilter: React.Dispatch<React.SetStateAction<"all" | "locked" | "active">>;
}

export const ButtonArray: React.FC<ButtonArrayProps> = ({ memberFilter, setMemberFilter }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userType = window.location.pathname.split("/").pop();
  const { provider, settingsDispatch } = useContext(GlobalContext);
  const [loggedInClient, setLoggedInClient] = useState<any>();

  useEffect(() => {
    setLoggedInClient(provider?.loggedInClient);
  }, [provider?.loggedInClient]);

  return (
    <StyledButtonContainer container>
      <Grid item xs={0.1} md={0.1} lg={0.2} xl={0.3} />
      {loggedInClient && loggedInClient.roles === "Client,Provider" && (
        <Grid item xs={3} md={2.2} lg={1.8} xl={1.5}>
          {userType !== "archived" && (
            <Button
              variant="primary"
              onClick={() => navigate(`${window.location.pathname}/new`)}
            >
              {t(userType === "members" ? "u-new-member" : "u-new-coordinator")}
            </Button>
          )}
        </Grid>
      )}
      <Grid item xs={0.5} md={1} lg={2} xl={3} />
      <Grid item xs={3} md={3} lg={2} xl={2}>
        <Stack direction="row" spacing={1}>
          <Button
            variant={userType === "coordinators" ? "warning" : "info"}
            locked={userType === "coordinators"}
            onClick={() => {
              navigate("/provider/coordinators");
            }}
          >
            {t("u-coordinators")}
          </Button>
          <Button
            variant={userType === "members" ? "warning" : "info"}
            locked={userType === "members"}
            onClick={() => {
              navigate("/provider/members");
            }}
          >
            {t("u-members")}
          </Button>
          <Button
            variant={userType === "archived" ? "warning" : "info"}
            locked={userType === "archived"}
            onClick={() => {
              navigate("/provider/archived");
            }}
          >
            Archived
            {/* {t("u-archived")} */}
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={0.5} md={1} lg={2} xl={3} />
      <Grid item xs={3} md={3} lg={2} xl={2}>
        <Stack direction="row" spacing={1}>
          {userType === "members" && (
            <>
              <Button
                variant={memberFilter === "all" ? "warning" : "info"}
                locked={memberFilter === "all"}
                onClick={() => setMemberFilter("all")}
              >
                {/* {t("u-all")} */}
                All
              </Button>
              <Button
                variant={memberFilter === "locked" ? "warning" : "info"}
                locked={memberFilter === "locked"}
                onClick={() => setMemberFilter("locked")}
              >
                {/* {t("u-locked")} */}
                Locked
              </Button>
              <Button
                variant={memberFilter === "active" ? "warning" : "info"}
                locked={memberFilter === "active"}
                onClick={() => setMemberFilter("active")}
              >
                {/* {t("u-active")} */}
                Active
              </Button>
            </>
          )}
        </Stack>
      </Grid>
      <Grid item xs={0.9} md={0.9} lg={1.8} xl={2.7} />
      <Grid item xs={1} md={1} lg={2} xl={2.5}>
        {/*<Stack direction="row" spacing={1}><Button id={'btn-all'} variant="info" onClick={handleFilterClick} disabled={true}>{t('u-all')}</Button><Button id={'btn-locked'} variant="primary" onClick={handleFilterClick}>{t('u-locked')}</Button><Button id={'btn-active'} variant="primary" onClick={handleFilterClick}>{t('u-active')}</Button><Button id={'btn-archive'} variant="primary" onClick={handleFilterClick}>{t('u-archive')}</Button></Stack>*/}
      </Grid>
    </StyledButtonContainer>
  );
};

export default function Provider() {
  const { t } = useTranslation();
  const {
    providerDispatch,
    configDispatch,
    devicesDispatch,
    notificationsDispatch,
    settingsDispatch,
    settings
  } = useContext(GlobalContext);
  // TODO: Can delete when gridload issue resolved
  // const [collectiveClient] = useState<any[]>([{ Unassigned: {} }]);
  // const [organizations] = useState<string[]>([]);
  const [loadingCoords, setLoadingCoords] = useState(false);
  const [loadingMems, setLoadingMems] = useState(false);
  const [loadingArch, setLoadingArch] = useState(false);
  const collectiveClient: Array<Record<string, Record<string, any>>> = [
    { Unassigned: {} }
  ];
  const organizations: string[] = [];
  const refreshInProgress = useRef(false);
  const refreshQueued = useRef(false);

  let orgSorter = (res: any) => {
    const sortValue = res.phone;
    if (sortValue && sortValue !== "-" && !organizations.includes(sortValue)) {
      organizations.push(sortValue);
      collectiveClient[0][sortValue] = { [res.id]: res };
    } else if (
      sortValue &&
      organizations.includes(sortValue) &&
      !Object.keys(collectiveClient[0][sortValue]).includes(res.id)
    ) {
      collectiveClient[0][sortValue][res.id] = res;
    } else if (
      sortValue === "-" &&
      !Object.keys(collectiveClient[0].Unassigned).includes(res.id)
    ) {
      collectiveClient[0].Unassigned[res.id] = res;
    }
  };

  const callRefresh = async () => {
    const refreshId = Date.now();

    const token = Session.crackCookieToken("provider");
    if (!token) return;
    // A refresh is already running; remember that another was requested so we
    // refresh once more on completion -- never drop the latest socket update.
    if (refreshInProgress.current) {
      refreshQueued.current = true;
      return;
    }

    refreshInProgress.current = true;

    setLoadingCoords(true);
    const coordPromise = API.kore.coordinator
      .getFullCoordList(Session.crackCookieToken("provider"))
      .then((list) => {
        const filteredList = (list ?? [])
          .filter((item: any) => item?.email !== "master@email.com")
          .map((item: any) => ({
            id: item?.id,
            email: item?.email,
            name: toLastFirstName(item?.username),
            phone: item?.phone || "-",
            role: item?.roles,
            lastActivity:
              moment(item?.updatedAt).format("MMM DD, YYYY HH:mm") || "-",
            registeredat: moment(item?.createdAt).format("MMM DD, YYYY") || "-",
          }));
        filteredList.forEach(orgSorter);
        providerDispatch({ type: "UPDATE_COORD_LIST", payload: filteredList });
      })
      .catch((err: any) => console.log("Error loading coordinators:", err))
      .finally(() => setLoadingCoords(false));
    const confPromise = API.kore.configurations.getConfigurations().then((conf) => {
      configDispatch({ type: "OPTIONS_UPLOAD", payload: conf });
    });
    setLoadingMems(true);
    const memPromise = API.kore.members
      .getAll(Session.crackCookieToken("provider"), "scope=provider&")
      .then((list) => {
        const filteredList = (list: KoreListInterface) => {
          return (list?.items ?? []).map((item: any) => {
            return {
              id: item?.id,
              email: item?.email,
              name: toLastFirstName(item?.username),
              firstName: item?.firstName,
              lastName: item?.lastName,
              phone: item?.phone || "-",
              lastactivity:
                moment(item?.updatedAt).format("MMM DD, YYYY HH:mm") || "-",
              registeredat:
                moment(item?.createdAt).format("MMM DD, YYYY") || "-",
              program: item?.program,
              gender: item?.gender,
              language: item?.language,
              groups: item?.groups,
              site: item?.site,
              enrollmentStatus: item?.enrollment?.status ?? "active",
              locked: item?.locked ?? false,
              birthDate: item?.birthDate,
              hubIds: item?.hubIds,
              // organization: item.organization,
            };
          });
        };
        const payload = filteredList(list);
        payload.forEach(orgSorter);
        providerDispatch({ type: "UPDATE_MEMBER_LIST", payload: payload });
      })
      .then(() => {
        providerDispatch({
          type: "UPDATE_ORGANIZATION_LIST",
          payload: collectiveClient
        });
      })
      .catch((err: any) => console.log("Error loading members:", err))
      .finally(() => setLoadingMems(false));
    const devPromise = API.kore.devices
      .getAll(Session.crackCookieToken("provider"), "-1")
      .then((list) => {
        devicesDispatch({ type: "UPDATE_DEVICES", payload: list });
      });
    const notifPromise = API.kore.notifications
      .getList(Session.crackCookieToken("provider"))
      .then((notifications) => {
        notificationsDispatch({
          type: "UPDATE_BREACHES",
          payload: notifications
        });
      })
      .catch((err) => console.log("notifications error"));
    setLoadingArch(true);
    const archPromise = API.kore.archived
      .getFullArchList(Session.crackCookieToken("provider"), "scope=provider&")
      .then((list) => {
        const filteredList = (list: KoreListInterface) => {
          return (list?.items ?? []).map((item: any) => {
            return {
              id: item?.id,
              fullName: `${item?.doc?.lastName}, ${item?.doc?.firstName}`,
              archivedAt: item?.archivedAt,
              entity: item?.entity,
              username: item?.doc?.username,
              externId: item?.doc?.externId
            };
          });
        };
        const payload = filteredList(list);
        payload.forEach(orgSorter);
        providerDispatch({ type: "UPDATE_ARCHIVED_LIST", payload: payload });
      })
      .catch((err: any) => console.log("Error loading archived:", err))
      .finally(() => setLoadingArch(false));

    // Release the guard only once every load has settled, so subsequent
    // refreshes (socket updates, retries) can repopulate the grids.
    Promise.allSettled([
      coordPromise,
      confPromise,
      memPromise,
      devPromise,
      notifPromise,
      archPromise
    ]).finally(() => {
      refreshInProgress.current = false;
      if (refreshQueued.current) {
        refreshQueued.current = false;
        callRefresh();
      }
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      callRefresh();
    }, 100);

    let socket: any;

    if (process.env.REACT_APP_NODE_ENV !== "development") {
      socket = io(socket_url);
      socket.on(`${host[0]}-provider-data-updates`, () => {
        callRefresh();
      });
    }

    API.kore.settings
      .getSingle("?entity=default", Session.crackCookieToken("coordinator"))
      .then((response: any) => {
        const data = response.data;

        if (!data.items || data.items.length === 0) {
          return API.kore.settings
            .create(defaultSettings(), Session.crackCookieToken("coordinator"))
            .then((createResponse: any) => {
              settingsDispatch({
                type: "CURRENT_DEFAULT_SETTINGS",
                payload: createResponse.data
              });
            });
        }

        settingsDispatch({
          type: "CURRENT_DEFAULT_SETTINGS",
          payload: data.items[0]
        });
      })
      .catch((err: any) => console.log("Error loading default settings:", err));
    return () => {
      clearTimeout(timeout);
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);

  return (
    <Grid container>
      <Grid item xs={1} />
      <Grid item xs={10}>
        <StyledContainer>
          <StyledHeader>{t("u-provider")}</StyledHeader>
          <Routes>
            <Route path="/*" element={
              <Users
                loadingCoords={loadingCoords}
                loadingMems={loadingMems}
                loadingArch={loadingArch}
              />}
            />
            <Route path="managers" element={<Managers />} />
            <Route path="managers/new" element={<Upsert type={"manager"} />} />
            <Route path="reports" element={<Reports />} />
            <Route path="statistics" element={<Statistics />} />
            <Route path="configurations" element={<Configurations />} />
            <Route path="global/thresholds" element={<GlobalThresholds />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/new" element={<NewOrder />} />
            <Route path="readings" element={<Readings />} />
          </Routes>
        </StyledContainer>
      </Grid>
      <Grid item xs={1} />
    </Grid>
  );
}
